/**
 * Phase 67-01 layer (d) — derives stale-kiosk subset from useMachines.
 *
 * A kiosk is stale when `is_online=true` AND `last_seen_at` is older than
 * STALE_MS. ALERT-ONLY: this hook does NOT trigger reboots — surfaces the
 * subset for badge + per-row icon rendering only.
 *
 * Spreads `...machines` so consumers get the full TanStack contract
 * (isLoading, isError, refetch).
 */

import { useMemo } from "react";

import { useMachines } from "@/hooks/queries/useMachines";

/** D-05 staleness threshold (15min). Matches backend STALE_THRESHOLD_SECONDS=900. */
export const STALE_MS = 15 * 60 * 1000;

export function useStaleKiosks() {
  const machines = useMachines();
  const filtered = useMemo(() => {
    if (!machines.data) return undefined;
    const cutoff = Date.now() - STALE_MS;
    return machines.data.filter(
      (m) =>
        m.is_online &&
        !!m.last_seen_at &&
        new Date(m.last_seen_at).getTime() < cutoff,
    );
  }, [machines.data]);

  return {
    ...machines,
    data: filtered,
  };
}
